import Icon from '../components/Icon.vue'

Icon.register({
  'caret-square-down': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM92.5 220.5L215.5 343.5C220.2 348.2 227.8 348.2 232.5 343.5L355.5 220.5C363.1 212.9 357.7 200 347 200H101C90.3 200 84.9 212.9 92.5 220.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-square-down.js
// module id = Nbi/
// module chunks = 144